import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RedirectCommand,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { KeycloakService, SessionStorageService } from '@ui/legacy-lib';
import { storageKeys } from '../../config/storage-keys.config';

export const AuthGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router = inject(Router);
  const keycloakService = inject(KeycloakService);
  const sessionStorage = inject(SessionStorageService);

  const token = keycloakService.token;

  sessionStorage.setItem(storageKeys.pathAfterAuth, {
    pathAfterAuth: state.url.split('?')[0],
    queryParams: route.queryParams
  });

  return token
    ? true
    : new RedirectCommand(
        router.parseUrl(`auth/login?pathAfterAuth=${state.url}`)
      );
};
